module.exports = __webpack_public_path__ + "img/undefined.805e608b.svg";